import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

const SEOHead = ({
  title,
  description,
  canonical = 'https://nodatx.com/',
  ogImage = 'https://nodatx.com/og-image.png',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  twitterSite = '@nodatx_ai',
  author = null,
  articleMeta = null,
  jsonLd = null,
}) => {
  const { t } = useTranslation()
  const defaultTitle = title || t('seo.defaultTitle', 'Nodatx — n8n Automation Experts | Save 20+ Hours Weekly')
  const defaultDescription = description || t('seo.defaultDescription', 'Nodatx helps you automate your business with n8n. We build custom workflows, CRM integrations, and AI-powered automation to save you time and boost efficiency.')
  const jsonLdArray = Array.isArray(jsonLd) ? jsonLd : (jsonLd ? [jsonLd] : [])

  return (
    <Helmet>
      <title>{defaultTitle}</title>
      <meta name="description" content={defaultDescription} />
      <link rel="canonical" href={canonical} />

      {author && <meta name="author" content={author} />}

      {/* Open Graph */}
      <meta property="og:title" content={defaultTitle} />
      <meta property="og:description" content={defaultDescription} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Nodatx" />

      {articleMeta && (
        <>
          {articleMeta.publishedTime && (
            <meta property="article:published_time" content={articleMeta.publishedTime} />
          )}
          {articleMeta.modifiedTime && (
            <meta property="article:modified_time" content={articleMeta.modifiedTime} />
          )}
          {articleMeta.author && (
            <meta property="article:author" content={articleMeta.author} />
          )}
          {articleMeta.tag && articleMeta.tag.map((tag, i) => (
            <meta key={i} property="article:tag" content={tag} />
          ))}
        </>
      )}

      {/* Twitter Card */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={defaultTitle} />
      <meta name="twitter:description" content={defaultDescription} />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content={twitterSite} />

      {/* JSON-LD Structured Data */}
      {jsonLdArray.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </Helmet>
  )
}

export default SEOHead
